/**
 * Relatórios não têm mais tela própria: o único acesso é o modal de Relatórios,
 * aberto pelo ícone de Configurações no canto superior direito.
 *
 * O modal vive no `AppBar` (estado local), então quem não é filho dele — uma
 * rota, o `navigateFromNotification`, um shim de link antigo — pede a abertura
 * por este evento de janela. Mesmo mecanismo já usado por `plan-upgrade-event`.
 */
export const OPEN_REPORT_MODAL_EVENT = 'clientbase:open-report-modal'

/**
 * Pede a abertura do modal de Relatórios. No-op fora do browser (SSR).
 */
export const openReportModal = (): void => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(OPEN_REPORT_MODAL_EVENT))
}
